// Put your application javascript here

// // Mobile menu trigger
// $(".navbar-toggler").on("click", function () {
//     $(this).toggleClass("open");
//     // $("#navbar-content").toggleClass("show");
// });

// let navToggler = document.querySelector('.navbar-toggler');

// navToggler.addEventListener('click', event => {
//     if (navToggler.classList.contains('open')) {
//         navToggler.classList.remove('open');
//     }
//     else {
//         navToggler.classList.add('open');
//     }
// });

async function postData(url = "", data) {
  console.log(data)
  // Default options are marked with *
  try{
  const response = await fetch(url, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "no-cors", // no-cors, *cors, same-origin
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    credentials: "same-origin", // include, *same-origin, omit
    headers: {
      "Content-Type": "application/json",
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: "follow", // manual, *follow, error
    referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    body: JSON.stringify(data), // body data type must match "Content-Type" header
  });
//   console.log(response)
  return response.json(); // parses JSON response into native JavaScript objects
  } catch (err) {
  	console.log(err)
  }
}


document.querySelectorAll(".buy-now").forEach((el) => {
  el.addEventListener("click", function(e) {
    e.preventDefault();
    const variant_id = Number(this.dataset.variantId);
    console.log(variant_id);
    var thisNew = this;
    const data = {
      items: [{
        quantity: 1,
        id: variant_id,
      }, ],
    };

    $.ajax({
      method: 'POST',
      url: "/cart/add.json",
      data: data,
      success: (data) => {
        //window.location.href = "/cart";
        /*if ( $(".upsell_product_main").length > 0) {
            Fancybox.show([{src: "#dialog-content2",type: "inline"}]);

        }
        else{
        window.location.href = "/cart";
        }*/
        window.location.href = "/cart";
      },
      error: (e) => {
        console.log(e)
      }
    })
  });
});
/* upsell Popup On Cart Page */
$(document).ready(function() {
    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    function upsell_Popup() {
        var upsellPopup = getCookie('upsellPopup');
      console.log(upsellPopup);
    if ( $(".upsell_product_main").length > 0 && upsellPopup != 'opened') {
        //if ( $(".upsell_product_main").length > 0) {
            //Set a cookie to set the popup open time
            setCookie('upsellPopup', 'opened', 5);
            Fancybox.show([{
                src: "#dialog-content2",
                type: "inline"
            }]);

        }
    }
    /*$('.cart__checkout--button').click(function(event){
      event.preventDefault();
       upsell_Popup();
    });*/
  if (window.location.href.indexOf('cart') > -1) {
    setTimeout(function() {
        upsell_Popup();
    }, 3000);
  }
  
    /*$('body').on('click', '.carousel__button', function() {
        // redirect to cart page on Popup button click
        if (window.location.href.indexOf('cart') > -1) {
				
        } else {
            window.location.href = '/cart';
        }

    });*/
   //$('.random_product').pick(3); 
  var parent = $(".random_product");

  var random = $(".random_product .upsell_product_main");
  $(random).hide();

  var divs = $(".random_product .upsell_product_main").get().sort(function(){ 
    return Math.round(Math.random());
  }).slice(0,3);
  $(divs).show();
});
/* popup Buy Button */

$('body').on("click", ".popup-buy-now", function(e) {
    e.preventDefault();
    const variant_id = Number(this.dataset.variantid);
    console.log(variant_id);
    var thisNew = this;
    const data = {
        items: [{
            quantity: 1,
            id: variant_id,
        }, ],
    };
   //var VPrice= $(this).parents('.upsell_product_main').find('.product_variantsPrice').html();
 
  $('.popup-buy-now:not(this)').html('Buy Now');
    $('.btn_message a').html('');
    $(this).html('Adding...');
    $.ajax({
        method: 'POST',
        url: "/cart/add.json",
        data: data,
        success: (data) => {
            //window.location.href = "/cart";
            $(this).html('Added to the cart');
            $(this).next('.btn_message').html("<a href='/cart'>View Cart<a>");
          var VPrice= $(this).parents('.upsell_product_main').find('.product_variantsPrice').html();
          
            /*if (window.location.href.indexOf('cart') > -1) {
              $('body').on('click', '.btn_message a', function(e) {
                e.preventDefault();
                $('body .carousel__button').trigger('click');

              });
            }*/
        }
    });
});
window.handleUpgrade = function () {
  return {
    product: null,
    email: null,
    serial: null,
    errorMessage: null,
    showError: false,
    loading: false,
    onInit() {
      this.product = document.querySelector("#productSelector").value;
      this.errorMessage = this.$el.dataset.errormessage;
    },
    handleSubmit() {
      var self = this;
      const data = {
        product: this.product,
        email: this.email,
        serial: this.serial,
      };
      console.log(data);
      $.ajax({
        method: 'POST',
        url: "https://moho.lostmarble.com/apps/upgrade",
        data: data,
        beforeSend: () => { self.loading = true },
        success: (data) => { 
          self.loading = false
          console.log(data)
          if (data?.variantId) {
            const variantId = data.variantId;
            const discountCode = data.discountCode;
            window.location.href =
              "/cart/" + variantId + ":1?discount=" + discountCode;
          }
        },
        error: (e) => { 
           console.log(e);
            self.showError = true;
            self.loading = false
        }
      })

//       postData("https://moho.lostmarble.com/apps/upgrade", data)
//         .then((data) => {
//           if (data?.variantId) {
//             const variantId = data.variantId;
//             const discountCode = data.discountCode;
//             window.location.href =
//               "/cart/" + variantId + ":1?discount=" + discountCode;
//           }
//         })
//         .catch((err) => {
//           console.log(err.error);
//           this.showError = true;
//         });
    },
  };
};
    
  